import request from "../base-request";

export interface ICompany {
	company: {
		id: string;
		name: string;
	};
	functions: {
		[key: string]: {
			state: "enabled" | "disabled" | "hidden";
			attributes: { [_anotherKey: string]: boolean | string };
		};
	};
	decimalPlaces?: number;
	default_timezone?: string;
	licenses?: string[];
	[key: string]: any;
}

export const getCompanySettings = async () => {
	const [company] = await request<ICompany>("/api/settings/company/");
	return company;
};

export const getCompanyLicenses = async () => {
	const [company] = await request<ICompany>(`/api/settings/company/`);
	const licenses = company?.licenses ?? [];
	return licenses;
};

type CompanyFieldsRawData = {
	fields: {
		id: string;
		name: string;
		type: string;
		tags: string[];
		"editable-by": string[];
		"visible-to": string[];
	}[];
};

export type CompanyFieldsData = {
	fields: {
		id: string;
		name: string;
		type: string;
		tags: string[];
		editableBy: string[];
		visibleTo: string[];
	}[];
};

export const getCompanyFields = async (companyID: string) => {
	const [fields] = await request<CompanyFieldsRawData>(`/api/v0.1/companies/${companyID}/fields/`);
	const formattedFields = fields?.fields.map((field) => {
		return {
			...field,
			editableBy: field["editable-by"],
			visibleTo: field["visible-to"],
		};
	});
	return formattedFields;
};

export interface SessionTimeoutData {
	timeout?: number;
	redirect?: string;
}

export interface UpdateSessionSettingsRequest {
	sessions?: SessionTimeoutData;
}

export interface SessionSettingsResponse {
	timeout?: number;
	sessionTimeoutRedirect?: string;
}

/**
 * Updates the company session settings (timeout and redirect)
 */
export const updateCompanySessionSettings = async (
	data: UpdateSessionSettingsRequest
): Promise<SessionSettingsResponse> => {
	const response = await request<{ data: SessionSettingsResponse }>("/api/authentication/sessions/", {
		method: "PATCH",
		body: JSON.stringify(data),
	});
	return response[0].data;
};
